import { render } from "./EnrolleeStatusEditOnboardComponent.vue?vue&type=template&id=9d273db2&scoped=true"
import script from "./EnrolleeStatusEditOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeStatusEditOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeStatusEditOnboardComponent.vue?vue&type=style&index=0&id=9d273db2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d273db2"]])

export default __exports__